import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { shopApi } from "@/lib/shopApi";
import { formatApiErrorDetail } from "@/lib/api";
import AuthShell, { primaryBtn } from "@/components/store/AuthShell";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading", msg: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) return setState({ status: "error", msg: "This verification link is missing its code." });
    shopApi.post("/member/auth/verify-email", { token })
      .then((r) => setState({ status: "ok", changed: r.data.email_changed }))
      .catch((e) => setState({ status: "error", msg: formatApiErrorDetail(e.response?.data?.detail) }));
  }, [params]);

  return (
    <AuthShell title="Email verification" testid="verify-email-page">
      {state.status === "loading" && <div className="flex items-center gap-3 text-slate-600"><Loader2 className="h-5 w-5 animate-spin" /> Verifying your email…</div>}
      {state.status === "ok" && (
        <div data-testid="verify-email-success">
          <div className="flex items-center gap-3 text-emerald-700"><CheckCircle2 className="h-6 w-6" /><span className="font-semibold">{state.changed ? "Your new email address is confirmed." : "Your email is verified."}</span></div>
          <Link to="/login?verified=1" className={`${primaryBtn} mt-6 inline-flex items-center justify-center`} data-testid="verify-go-login">Log in to shop</Link>
        </div>
      )}
      {state.status === "error" && (
        <div data-testid="verify-email-error">
          <div className="flex items-start gap-3 text-rose-700"><XCircle className="mt-0.5 h-6 w-6 shrink-0" /><span>{state.msg}</span></div>
          <p className="mt-4 text-sm text-slate-600">Try logging in — you can request a new link from there.</p>
          <Link to="/login" className={`${primaryBtn} mt-6 inline-flex items-center justify-center`} data-testid="verify-error-login">Go to log in</Link>
        </div>
      )}
    </AuthShell>
  );
}
